import { render, staticRenderFns } from "./RuleItem.vue?vue&type=template&id=2f354306&scoped=true"
import script from "./RuleItem.vue?vue&type=script&setup=true&lang=js"
export * from "./RuleItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RuleItem.vue?vue&type=style&index=0&id=2f354306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f354306",
  null
  
)

export default component.exports